import { StatesModule, Transition } from '@uirouter/angular';
import { Ng2StateDeclaration } from '@uirouter/angular';
import { ChecklistReportListComponent } from '@fi-app/checklist-report/list/checklist-report-list.component';
import { IChecklistListStateModel } from '@fi-app/checklist/checklist';
import { PageTitleService } from '@fi-app/utilities/fi-services/page-title.service';
import { ObjectTypes } from '@fi-shared/types/object-type';
import { ChecklistReportViewComponent } from '@fi-app/checklist-report/checklist-report-view.component';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { ChecklistReportService } from '@fi-app/checklist-report/checklist-report.service';
import { ChecklistModel } from '@fi-app/checklist/checklist.model';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { FiAbstractStateComponent } from '@fi-shared/fi-state-proxy/fi-abstract-state.component';

const ChecklistListReportsState: Ng2StateDeclaration = {
    name: FiStateNames.Checklist.Report._name,
    url: '/Reports',
    abstract: true,
    component: FiAbstractStateComponent,
};

const ChecklistListReportsListState: Ng2StateDeclaration = {
    name: FiStateNames.Checklist.Report.List,
    url: '/?:filterType&:sortColumn&:sortDirection&:offset',
    resolve: {
        pageTitle: [PageTitleService, ChecklistListReportsList_pageTitle],
    },
    component: ChecklistReportListComponent,
    reloadOnSearch: false,
};

export function ChecklistListReportsList_pageTitle(ccmPageTitle: PageTitleService) {
    return ccmPageTitle.setTitleByItem(ObjectTypes.CheckListReport);
}

const ChecklistReportViewState: Ng2StateDeclaration = {
    name: FiStateNames.Checklist.Report.View,
    url: '/{Id:[0-9]+}?:status&:unitId&:startDate&:endDate',
    reloadOnSearch: false,
    views: {
        '@Module': {
            component: ChecklistReportViewComponent,
        },
    },
    resolve: {
        checklist: [FiStateService, Transition, ChecklistReportService, ChecklistReportView_checklist],
        pageTitle: [PageTitleService, 'checklist', ChecklistReportView_pageTitle],
        selections: [ChecklistReportService, FiStateService, Transition, ChecklistReportView_selections],
        businessUnitsData: [ChecklistReportService, FiStateService, Transition, ChecklistReportView_businessUnitsData],
        businessAreasData: [ChecklistReportService, FiStateService, Transition, ChecklistReportView_businessAreasData],
        reportNames: [ChecklistReportService, ChecklistReportView_reportNames],
    },
};
export function ChecklistReportView_checklist(
    stateService: FiStateService,
    transition: Transition,
    checklistReportsService: ChecklistReportService,
) {
    return checklistReportsService.getCheckListReport(stateService.getParams(transition).Id);
}
export function ChecklistReportView_pageTitle(ccmPageTitle: PageTitleService, checklist: ChecklistModel) {
    return ccmPageTitle.setTitle(checklist.Name);
}
export function ChecklistReportView_selections(
    checklistReportsService: ChecklistReportService,
    stateService: FiStateService,
    transition: Transition,
) {
    return checklistReportsService.getCheckListReportSelections(stateService.getParams(transition).Id);
}
export function ChecklistReportView_businessUnitsData(
    checklistReportsService: ChecklistReportService,
    stateService: FiStateService,
    transition: Transition,
) {
    return checklistReportsService.getBusinessUnitsForCheckListReports(stateService.getParams(transition).Id);
}
export function ChecklistReportView_businessAreasData(
    checklistReportsService: ChecklistReportService,
    stateService: FiStateService,
    transition: Transition,
) {
    return checklistReportsService.getBusinessAreasForCheckListReports(stateService.getParams(transition).Id);
}
export function ChecklistReportView_reportNames(checklistReportsService: ChecklistReportService) {
    return checklistReportsService.getCheckListReportNames();
}

export const ChecklistReportStates: StatesModule = {
    states: [ChecklistListReportsState, ChecklistListReportsListState, ChecklistReportViewState],
};
